import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ThumbDown from '@johnlewispartnership/wtr-ingredients/dist/Icon/ThumbsDown';
import Button from '@johnlewispartnership/wtr-ingredients/dist/Button';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { LabeledControl } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/LabeledControl';
import { Radio } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Radio';
import ThankYouMessage from '../../../components/CustomerFeedback/ThankYouMessage';
import styles from './index.module.scss';
const friendlyString = (string, separator = '_') => string
    .toLowerCase()
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .replace(/ /g, separator);
const FeedbackSelector = ({ options, onSubmit }) => {
    const [feedback, setFeedback] = useState({ value: null, isSubmitted: false });
    const submitFeedback = () => {
        onSubmit(feedback.value);
        setFeedback(Object.assign(Object.assign({}, feedback), { isSubmitted: true }));
    };
    if (feedback.isSubmitted) {
        return React.createElement(ThankYouMessage, null);
    }
    return (React.createElement("div", { className: styles.container, "data-testid": "feedback-selector" },
        React.createElement(ThumbDown, { className: styles.icon }),
        React.createElement("div", { className: styles.message },
            React.createElement(Typography, { styleAs: "sectionHeadingLight", noMargins: true }, "We're sorry you didn't find this information helpful. Please tell us why.")),
        options.map(option => {
            const key = friendlyString(option);
            return (React.createElement(LabeledControl, { key: key, id: key, className: styles.labeledControl, control: React.createElement(Radio, { name: "feedback", value: `no - ${option}`, onChange: e => setFeedback(Object.assign(Object.assign({}, feedback), { value: e.target.value })) }), label: option, boxed: true }));
        }),
        React.createElement(Button, { label: "Send feedback", width: "full", disabled: !feedback.value, onClick: submitFeedback })));
};
FeedbackSelector.displayName = 'FeedbackSelector';
FeedbackSelector.defaultProps = {
    options: [],
};
FeedbackSelector.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string),
    onSubmit: PropTypes.func.isRequired,
};
export default FeedbackSelector;
//# sourceMappingURL=index.js.map